export default () => {
    return [
        {
            path: '/dictionary',
            name: 'dictionary',
            component: () => import('./views/dictionary.vue'),
        },
    ];
};
